import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 快递物流服务
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class ExpressService extends ServiceBase {
    
    /**
     * 新增/修改模版
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async operationTemplate(data: any): Promise<IHttpResponse>
    {
        let response;
        if(data.id)
        {
            response = await this.apis.editTemplate({ data });
        }
        else
        {
            response = await this.apis.addTemplate({ data });
        }
        
        return response;
    }

    /**
     * 获取模版列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getTemplatePage(data:any): Promise<IHttpResponse>
    {
        let response = await this.apis.getTemplatePage({data});
        
        return response;
    }

    /**
     * 获取模版详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getTemplateDetail(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.getTemplateDetail({
            urlPath:{id}
        });
        
        return response;
    }

    /**
     * 删除模版
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async deleteTemplate(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.deleteTemplate({
            urlPath:{id}
        });
        
        return response;
    }

    /**
     * 获取快递公司列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getExpressList(): Promise<IHttpResponse>
    {
        let response = await this.apis.getExpressList({});
        
        return response;
    }

    /**
     * 获取运费模版列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getExpressTemplateList(): Promise<IHttpResponse>
    {
        let response = await this.apis.getExpressTemplateList({});
        
        return response;
    }

}